const i={color:"currentColor",easing:"ease-out",duration:400,dissolveDuration:300,delay:75,initialOpacity:.2,finalOpacity:.1,considerDisabledAttr:!0,turnOff:!1};export{i as defaultOptions};
